import { Widget, mk_widget, Action } from "widgets-for-react";
import * as React from "react";
import { FooterMenus, PublicSiteState } from "../../public_site.main.mod";
import NavItems from "./nav_items";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { AppState } from "../../cms/state/types.gen";
import { PublicSiteCustomRoutes } from "../custom_pages/types.mod";
import { gtmPush } from "../../../helpers";
import { link } from "../../cms/blocks/utils.gen";
import { wysiwyg } from "./wysiwyg.mod";
import FooterColumn from "./footer_columns";
import { Icons } from "./icons";
import FooterColumns from "./footer_columns";

export const footer: (
         s: AppState<PublicSiteState, PublicSiteCustomRoutes>
       ) => Widget<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>> = (props) =>
         mk_widget({
           run: (o) => (
             <>
               {/* TODO: adjust as styleegude footer */}
               <footer className="footer">
                 <div className="footer__inner container--m grid--spacing">
                   <div className="footer__logos">
                     <a className="footer__logo" href={window.wp.language == 'nl' ? '/' : '/en'}>
                       <img src="/frontend/images/Logo--white.svg" alt="Dubbeldam logo" />
                     </a>
                     <a className="footer__logo footer__logo--parent" href="https://dubbeldamholding.com/" target="_blank" rel="noopener noreferrer">
                        <img src="/frontend/images/logo--dubbeldam-holding.png" alt="Dubbeldam Holding logo" width="380" height="83" />
                      </a>
                     <a className="footer__logo footer__logo--partner" href="https://www.viabovag.nl/" target="_blank" rel="noopener noreferrer">
                       <img src="/frontend/images/logo--bovag.jpg" alt="bovag logo" width="75" height="113" />
                     </a>
                   </div>

                   <nav className="footer__nav nav nav--footer typo--2xs">
                     <NavItems location="footer" cssClass={'bottom'} hasActiveState={false} />
                   </nav>


          <div className="footer__socials typo--2xs">
            <h2 className="socials__title typo--2xs">{t("footer.follow_us")}</h2>
            <ul className="socials">
              <li className="socials__item">
                <a className="socials__link socials__link--linkedin" target="_blank" href="https://www.linkedin.com/company/1739354"></a>
              </li>
              <li className="socials__item">
                <a className="socials__link socials__link--youtube" target="_blank" href="https://www.youtube.com/channel/UCjHrCzmI7AmyHGjBBT48ZUg/"></a>
              </li>
               <li className="socials__item">
                <a className="socials__link socials__link--facebook" target="_blank" href="https://www.facebook.com/Dubbeldamgroep"></a>
              </li>
               <li className="socials__item">
                <a className="socials__link socials__link--instagram" target="_blank" href="https://www.instagram.com/dubbeldam_groep"></a>
              </li>
            </ul>

            <NavItems location='copyright' cssClass={'copyright typo--4xs'} hasActiveState={false}
            // after={
            //   <li className="nav__item nav__item--copyright">
            //     <a className="optanon-toggle-display nav__link nav__link--copyright">Cookie settings</a>
            //   </li>
            // }
            />
          </div>
        </div>
      </footer>
      </>
    )
  });
